// extracted by mini-css-extract-plugin
module.exports = {"xlarge":"price_xlarge__3nyxr","unit":"price_unit___oc2O","integer":"price_integer__1gOp5","large":"price_large__GUfop","middle":"price_middle__3JEal","small":"price_small__1_MMI"};